import React, { ReactElement } from 'react'
import { formatDate, formatDayOfWeek } from '../helpers/format'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Entry } from './Entry.d'

/** Used only in EntryThumbnail. */
const EntryTitleLine = (props: { entry: Entry, className?: string }): ReactElement => {
    return <h3 className={ props.className || undefined }>
        { isNaN(new Date(props.entry.date).getTime())
            ? 'Invalid date'
            : formatDayOfWeek(props.entry.date) + ' ' + formatDate(props.entry.date, 'long') }
        {props.entry.title && <> &bull; <span className="entry-title">{props.entry.title}</span></>}
        { props.entry.status === 'deleted'
          && <span title="This entry has been deleted, and will vanish when processing is next run."> <FontAwesomeIcon icon="ban" /></span>}
    </h3>
}

export default EntryTitleLine
